import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useMenuStore } from '../utils/stores/useMenuStore';
import BloodTestBanner from './BloodTestBanner';

const FloatingBloodTestBanner: React.FC = () => {
  const location = useLocation();
  const [isBannerExpanded, setIsBannerExpanded] = useState(false);
  const { isOpen: isMenuOpen } = useMenuStore();
  
  // Only show on home page
  const isHomePage = location.pathname === '/home';
  
  // Collapse banner when menu opens to ensure clean state
  useEffect(() => {
    if (isMenuOpen && isBannerExpanded) {
      setIsBannerExpanded(false);
    }
  }, [isMenuOpen, isBannerExpanded]);
  
  // Hide banner if not on home page or if menu is open
  if (!isHomePage || isMenuOpen) {
    return null;
  }

  return (
    <>
      {/* Backdrop blur overlay - only when banner is expanded */}
      {isBannerExpanded && (
        <div className="fixed inset-0 bg-black/20 backdrop-blur-sm z-30 md:z-20" />
      )}
      
      {/* Mobile: Floating over navbar */}
      <div className="fixed bottom-[100px] left-0 right-0 z-40 px-4 pb-2 md:hidden">
        <BloodTestBanner onExpandedChange={setIsBannerExpanded} />
      </div>
      
      {/* Desktop: Attached to bottom of page */}
      <div className="hidden md:block fixed bottom-0 left-[100px] right-0 z-30 px-8 pb-4">
        <BloodTestBanner onExpandedChange={setIsBannerExpanded} />
      </div>
    </>
  );
};

export default FloatingBloodTestBanner; 